module.exports = function getResource(label, vars = []) {
    const resources = {
        noShippingAddressRequired: 'No shipping address or payment is required for this order. Please review your information before placing your order.',
        noPaymentRequired: 'No payment is required for this order. Please review your information before placing your order.',
        pleaseReviewOrder: `Please review your order information before ${vars[0]}`,
        termsConditions: 'Terms & Conditions',
        andText: ' and ',
        privacyPolicy: 'Privacy Policy',
        pleaseReviewOrderInfoText: 'Please review your order information before placing your order.',
        byPlacingOrderCaText: 'By placing your order, you agree to be bound by the ',
        termsOfPurchase: 'Terms of Purchase',
        termsOfUse: 'Terms of Use'
    };
    return resources[label];
};
